import { EmptyState } from '@/components/EmptyState';
import { Truck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { PageHeader } from '@/components/PageHeader';

export const Suppliers = () => {
  const { selectedCondominium } = useAuth();
  const userRole = selectedCondominium?.role || 'RESIDENT';
  const canEdit = ['ADMIN', 'ACCOUNTANT'].includes(userRole);

  return (
    <div className="space-y-8" data-testid="suppliers-page">
      <PageHeader
        title="Fornitori"
        subtitle={canEdit ? 'Gestione fornitori e prestatori di servizi' : 'Consulta l\'elenco dei fornitori del condominio'}
        actions={canEdit ? (
          <Button className="bg-white text-primary hover:bg-white/90" data-testid="add-supplier-button">
            Aggiungi Fornitore
          </Button>
        ) : undefined}
      />

      <EmptyState
        icon={Truck}
        title="Nessun fornitore registrato"
        description={canEdit ? 'Aggiungi i fornitori che lavorano con il condominio' : 'Non ci sono fornitori registrati per questo condominio'}
      />
    </div>
  );
};